import { whatIfInnerSelector, whatIfOptionsOrDefaultSelector } from '../../WhatIfsSelector';

export const principalAdditionalCoverageSelector = (state, props) =>
  whatIfInnerSelector(state, props).PrincipalAdditionalCoverage;

export const spouseAdditionalCoverageSelector = (state, props) =>
  whatIfInnerSelector(state, props).SpouseAdditionalCoverage;

export const principalNameSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).PrincipalName;

export const spouseNameSelector = (state, props) =>
  whatIfOptionsOrDefaultSelector(state, props).SpouseName;

export const hasSpouseSelector = (state, props) =>
  !!whatIfOptionsOrDefaultSelector(state, props).SpouseName;
